import { useTranslation } from 'react-i18next';

const NoPage = () => {
  const { t } = useTranslation();
  return <h1>{t('404')}</h1>;
}

export default NoPage;
